/**
 * 注册密码规则：长度 8–32；须含小写、大写、数字，以及至少一个符号
 *（`\p{L}` 字母、`\p{N}` 数字、`\p{Z}` 空白分隔符以外的字符）。
 */
export const REGISTER_PASSWORD_SYMBOL_RE = new RegExp('[^\\p{L}\\p{N}\\p{Z}]', 'u');

export function isValidRegisterPassword(value: string | number | undefined | null): boolean {
  const s = String(value ?? '');
  if (s.length < 8 || s.length > 32) return false;
  if (!/[a-z]/.test(s)) return false;
  if (!/[A-Z]/.test(s)) return false;
  if (!/[0-9]/.test(s)) return false;
  if (!REGISTER_PASSWORD_SYMBOL_RE.test(s)) return false;
  return true;
}
